



































































































































































































































































































































































































































import IOutbound from '@/store/models/IOutbound';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';
import ICustomer from '@/store/models/ICustomer';
import IGood from '@/store/models/IGood';
import IListStatusOutbound from '@/store/models/IListStatusOutbound';
import Snackbar from '@/components/shared/Snackbar.vue';
import moment from 'moment';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import IAuthentication from '@/store/models/IAuthentication';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import { ListInboundTypes } from '@/components/shared/ListInboundTypes';
import { ListOutboundTypes } from '@/components/shared/ListOutboundTypes';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import IListTypesOutbounds from '../../../store/models/IListTypesOutbounds';

@Component({
    components: {
        Snackbar
    }
})
export default class OutboundSelector extends Vue {
    searchOutbound: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'dateOut';
    sortDesc: boolean = true;
    showCompletedOutbounds: boolean = false;
    headers: any = [
        { text: 'Company Source', align: 'start', value: 'companySourceName' },
        { text: 'Company Destination', value: 'companyDestinationName' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Customer Destination', value: 'customerDestinationName' },
        { text: 'Customer Destination Country', value: 'customerDestinationCountry' },
        { text: 'Dossier Number Source', value: 'code' },
        { text: 'Dossier Number Destination', value: 'codeDestination' },
        { text: 'Type', value: 'listTypesOutboundsName' },
        { text: 'Estimated Time of Departure', value: 'dateOut' },
        { text: 'Status', value: 'statusName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IOutbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateOut: new Date(),
        dossierNumber: "",
        weight: 0,
        liters: 0,
        deliveriesNumber: 0,
        description: "",
        containerNumber: "",
        sealNumber: "",
        orderNumber: "",
        startTime: 0,
        endTime: 0,
        dateChanged: false,
        entrepot: "",
        agp: "",
        referenceInboundCode: "",
        createdDate: new Date(),
        customerDestination: "",
        codeDestination: "",
        idListTypesOutbounds: "",
        listTypesOutboundsName: "",
        statusColor: "",
        customerDestinationCountry: ""
    }
    defaultItem : IOutbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateOut: new Date(),
        dossierNumber: "",
        weight: 0,
        liters: 0,
        deliveriesNumber: 0,
        description: "",
        containerNumber: "",
        sealNumber: "",
        orderNumber: "",
        startTime: 0,
        endTime: 0,
        dateChanged: false,
        entrepot: "",
        agp: "",
        referenceInboundCode: "",
        createdDate: new Date(),
        customerDestination: "",
        codeDestination: "",
        idListTypesOutbounds: "",
        listTypesOutboundsName: "",
        statusColor: "",
        customerDestinationCountry: ""
    }

    @Prop({ type: Array, required: true })
    OutboundList !: IOutbound[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop({ type: Array, required: true })
    CustomerList !: ICustomer[];
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop({ type: Array, required: true })
    StatusOutboundsList !: IListStatusOutbound[];
    @Prop({ type: Array, required: true })
    TypesOutboundsList !: IListTypesOutbounds[];
    @Prop({ type: Boolean, default: false })
    loading !: boolean;
    @Prop({ type: Array, required: true })
    OutboundDetailList !: IOutboundDetail[];
    @Prop()
    OutboundCodeSelectedFromDashboard !: string;
    @Prop({ type: Array, required: true })
    AvailableTimeSlots !: Number[];
    @Prop()
    UserName !: string;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedOutbounds !: boolean;
    @Prop()
    value!: IOutbound | null;
    @Prop()
    CompanyId !: string;
    @Prop({ type: Boolean, default: false })
    IsStandAlone !: boolean;
    @Prop({ type: Boolean, default: false })
    HasLicensePlanning !: boolean;
    
    selectedOutbound: IOutbound[] = [];
    selectedCompanySource: ICompany = {} as ICompany;
    selectedCompanyDestination: ICompany = {} as ICompany;
    selectedCustomer: ICustomer = {} as ICustomer;
    selectedStatusOutboundChange: IListStatusOutbound | null = null;
    originalStatusId: string = "";
    originalStatusName: string = "";
    pendingNotificationText: string = "";
    selectedTypesOutbound: IListTypesOutbounds = {} as IListTypesOutbounds;
    dateOut: string = new Date().toISOString().substr(0, 10);
    menu2: boolean = false;
    dialogStatus : boolean = false;
    isValidStatus: boolean = true;
    notificationText: string = "";
    selectedStartTime: number = 0;
    selectedEndTime: number = 0;
    availableTimeSlotsLocal: number[] = [];
    AvailableTimeSlotsEndTime: number[] = [8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21];
    settingsCompanyApi: SettingsCompanyApi;
    // date: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
   
    constructor() {
        super();
        this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
        if (this.IsStandAlone) {
            this.selectedStartTime = 6;
            this.selectedEndTime = 7;
        }
    }

    get date() {
        const today = new Date();
        const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
        return twoMonthsAgo.toISOString().substr(0, 10);
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Outbound' : 'Edit Outbound'; }

    get DateOutFormatted() {
        return this.formatDate(this.dateOut);
    }

    get CanEdit() {
        return this.OutboundDetailList.length > 0;
    }

    get CompanySource() {
        const c = this.CompanyList.find(x => x.id === this.CompanyId);
        return c ? [c] : [];
    }
    get isReadOnlyMode(): boolean {
        const isCompleted =
            this.editedItem &&
            ((this.editedItem.statusName || '') + '').toLowerCase() === 'completed';

        return isCompleted && !this.CanModifyCompletedOutbounds;
    }

    get IsCompanySourceDifferentFromMyCompany(): boolean {
        return (
            this.selectedCompanySource &&
            (this.selectedCompanySource as any).id &&
            this.selectedCompanySource.id !== this.CompanyId
        );
    }

    get canEditOutboundType(): boolean {
        const srcId =
            (this.selectedCompanySource && (this.selectedCompanySource as any).id)
                ? (this.selectedCompanySource as any).id
                : (this.editedItem && (this.editedItem as any).idCompanySource) || '';

        return !!this.CompanyId && srcId === this.CompanyId;
    }

    get isCurrentStatusExternal(): boolean {
        if (this.editedIndex === -1) return false;
        if (!this.editedItem || !this.editedItem.idStatus) return false;
        if (!this.StatusOutboundsList || this.StatusOutboundsList.length === 0) return true;

        return !this.StatusOutboundsList.some(s => s.id === this.editedItem.idStatus);
    }

    get currentStatusHint(): string {
        if (this.isCurrentStatusExternal) {
            return "This status was set by another company. You can still change it to one of your company statuses.";
        }
        return "This is the current status. You can change it to another status defined in your company.";
    }

    get myCompany(): ICompany {
        return (this.CompanyList.find(c => c.id === this.CompanyId) || ({} as ICompany)) as ICompany;
    }

    @Watch('selectedCompanySource')
    onChangeSelectedCompanySource() {
        this.$emit("loadTimeSlots", this.dateOut, false, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    @Watch('selectedCompanyDestination')
    onChangeSelectedCompanyDestination() {
        this.$emit("loadTimeSlots", this.dateOut, false, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    @Watch('dateOut')
    onChangeDateOut() {
        const currentEditedDate = this.editedIndex > -1 ? this.convertDate(new Date(this.editedItem.dateOut)) : null;
        const dateChanged = this.editedIndex > -1 && currentEditedDate !== this.dateOut;

        if (dateChanged) {
            this.selectedStartTime = 0;
            this.selectedEndTime = 0;
        }

        this.$emit("loadTimeSlots", this.dateOut, dateChanged, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    get customersFiltered() : ICustomer[] {
        return this.CustomerList.filter(c => c.idCompany === this.selectedCompanySource.id) as ICustomer[];
    }

    get availableEndTimesLocal(): number[] {
    // Solo permitir endTimes > startTime
        if (!this.selectedStartTime) return this.AvailableTimeSlotsEndTime.slice();
        return this.AvailableTimeSlotsEndTime.filter(h => h > this.selectedStartTime);
    }

    @Watch('selectedStartTime')
    onChangeSelectedStartTime(newVal: number) {
        if (!newVal || newVal === 0) return;

        const preferred = newVal + 1;
        const candidates = this.availableEndTimesLocal;

        // si preferred existe, úsalo; si no, usa el primer end válido; si no hay, usa preferred
        const nextEnd =
            candidates.indexOf(preferred) !== -1
                ? preferred
                : (candidates.length > 0 ? candidates[0] : preferred);

        // Autocálculo si está vacío, o si quedó inválido (<= start), o si es un "New Outbound"
        if (this.selectedEndTime === 0 || this.selectedEndTime <= newVal || this.editedIndex === -1) {
            this.selectedEndTime = nextEnd;
        }
    }

    @Watch('OutboundCodeSelectedFromDashboard')
    onChangeOutboundCodeSelectedFromDashboard() {
        this.searchOutbound = this.OutboundCodeSelectedFromDashboard;
    }

    @Watch('showCompletedOutbounds')
    onChangeShowCompletedOutbounds() {
        this.$emit('showCompletedOutbounds', this.showCompletedOutbounds);
    }

    @Watch("AvailableTimeSlots", { immediate: true, deep: true })
    onAvailableTimeSlotsChanged(newVal: number[]) {
        this.availableTimeSlotsLocal = (newVal || []).slice();
    }

    @Watch('selectedStatusOutbound')
    onChangeStatusOutbound() {
        if (!this.selectedStatusOutboundChange || !this.selectedStatusOutboundChange.id) return;

        const newStatus = (this.selectedStatusOutboundChange.name || '').toLowerCase();
        const currentStatus = ((this.editedItem.statusName || '') + '').toLowerCase();

        // ✅ No permitir Completed si no hay detalles
        if (newStatus === 'completed' && this.OutboundDetailList.length === 0) {
            this.$emit('showMessageWarning', 'Cannot set status to Completed: outbound has no details.');

            // revertir selector
            const local = this.StatusOutboundsList.find(s => (s.name || '').toLowerCase() === currentStatus);
            this.selectedStatusOutboundChange = local || null;
            return;
        }

        // ✅ Notificación solo si cambia y no es Pending
        if (newStatus !== 'pending' && newStatus !== currentStatus) {
            this.notificationText = "";
            this.dialogStatus = true;
        }
    }

    private applyStatusIfValid() {
        if (!this.selectedStatusOutboundChange || !this.selectedStatusOutboundChange.id) return;

        const exists = this.StatusOutboundsList && this.StatusOutboundsList.some(s => s.id === this.selectedStatusOutboundChange!.id);
        if (!exists) return;

        // ✅ Revalidación Completed sin details
        const newName = (this.selectedStatusOutboundChange.name || '').toLowerCase();
        if (newName === 'completed' && this.OutboundDetailList.length === 0) return;

        this.editedItem.idStatus = this.selectedStatusOutboundChange.id;
        this.editedItem.statusName = this.selectedStatusOutboundChange.name;
    }

    @Watch('value')
    updateSelection(newValue : IOutbound | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedOutbound = [];
        } else {
            this.selectedOutbound = [newValue];
            this.$emit('outboundChanged', this.selectedOutbound[0]);
        }
    }

    HasRightModifyCompletedOutbounds() {
        if (this.showCompletedOutbounds && !this.CanModifyCompletedOutbounds) return false;
        return true;
    }

    closeDialogStatus() : void {
        this.dialogStatus = false;
        this.$nextTick(() => {
            this.notificationText = "";
        });
    }

    saveNotification() {
        const code = (this.editedItem && this.editedItem.code) ? this.editedItem.code : '';
        const statusName = (this.selectedStatusOutboundChange && this.selectedStatusOutboundChange.name)
            ? this.selectedStatusOutboundChange.name
            : '';

        if (!statusName) {
            this.closeDialogStatus();
            return;
        }

        let msg = "";
        if (this.notificationText === "") {
            msg = `\n The user ${this.UserName} has changed the outbound ${code} to status ${statusName}`;
        } else {
            msg = `\n The user ${this.UserName} has changed the outbound ${code} to status ${statusName} Comment : ${this.notificationText}`;
        }

        // ✅ Guardar como pendiente para enviarlo solo si el save/edit va OK
        this.pendingNotificationText = msg;

        // ✅ Añadir al description para persistirlo
        this.editedItem.description += msg;

        this.closeDialogStatus();
    }

    ResetOutbound() {
        this.selectedOutbound = [];
        if (this.IsStandAlone) {
            let index : number = this.CompanyList.findIndex(c => c.id === this.CompanyId);
            if (index !== -1) {
                this.selectedCompanySource = this.CompanyList[index];
                this.selectedCompanyDestination = this.CompanyList[index];
            }
            this.availableTimeSlotsLocal = [7, 8, 9, 10, 11, 13, 14, 15, 17, 18, 19, 20, 21];
            this.selectedStartTime = 7;
            this.selectedEndTime = 8;
        } else {
            this.selectedCompanySource = this.myCompany;
            this.selectedCompanyDestination = {} as ICompany;
            this.selectedStartTime = 0;
            this.selectedEndTime = 0;
        }
        
        this.selectedCustomer = {} as ICustomer;
        this.selectedStatusOutboundChange = this.StatusOutboundsList.find(c => c.name.toLowerCase() === "pending") as IListStatusOutbound;
        this.selectedTypesOutbound = this.TypesOutboundsList.find(c => c.name.toLowerCase() === ListInboundTypes.Types.Vrij) as IListTypesOutbounds;
        this.dateOut = new Date().toISOString().substr(0, 10);
        this.$emit("loadTimeSlots", this.dateOut, true, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
        this.$emit('resetOutbound');
    }

    editOutbound (item: IOutbound) {
        this.editedIndex = this.OutboundList.indexOf(item);
        if (item.startTime) {
            if (this.availableTimeSlotsLocal.indexOf(item.startTime) === -1) {
                this.availableTimeSlotsLocal.push(item.startTime);
            }
        }
        this.selectedCompanySource = this.CompanyList.find(c => c.id === item.idCompanySource) as ICompany || this.myCompany;
        this.selectedCompanyDestination = this.CompanyList.find(c => c.id === item.idCompanyDestination) as ICompany;
        this.selectedCustomer = this.CustomerList.find(c => c.id === item.idCustomer) as ICustomer;
        if (item.customerName === "") {
            this.selectedCustomer.name = "";
        }
        const local = this.StatusOutboundsList.find(s => s.id === item.idStatus);
        this.selectedStatusOutboundChange = local || null;
        let index: number = this.TypesOutboundsList.findIndex(c => c.id === item.idListTypesOutbounds);
        if (index !== -1) {
            this.selectedTypesOutbound = this.TypesOutboundsList[index];
        } else {
            index = this.TypesOutboundsList.findIndex(c => c.name.toLowerCase() === ListInboundTypes.Types.Vrij);
            if (index !== -1) {
                this.selectedTypesOutbound = this.TypesOutboundsList[index];
            }
        }
          
        this.originalStatusId = item.idStatus;
        this.originalStatusName = item.statusName;
        this.selectedStartTime = item.startTime;
        this.selectedEndTime = item.endTime;
        this.dateOut = moment(new Date(item.dateOut)).format('YYYY-MM-DD');
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
        this.dialogStatus = false;
        this.$emit("loadTimeSlots", this.dateOut, false, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    convertDate(date: Date) {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }

    async saveOutbound(outbound: IOutbound) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            let userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
            let settingsCompany = SettingsCompany.Settings.CanDuplicateOutboundsCode;

            if (this.selectedCustomer !== undefined && Object.keys(this.selectedCustomer).length === 0) {
                this.$emit('showMessageWarning', 'Customer is required!');
                return;
            }

            let index = this.OutboundList.findIndex(s => s.code === this.editedItem.code);
            let slot = 0;
            let canSave = true;

            if ((this.editedIndex > -1 && this.editedIndex !== index && index !== -1) || (this.editedIndex === -1 && index > -1)) {
                canSave = false;
            } else if (this.selectedEndTime - this.selectedStartTime > 1) {
                for (let i = this.selectedStartTime; i < this.selectedEndTime; i++) {
                    const countAtSlot = this.AvailableTimeSlots.filter(slot => slot === i).length;
                    if (countAtSlot >= 3) {
                        canSave = false;
                        slot = i;
                        break;
                    }
                }
            } else if (this.selectedEndTime < this.selectedStartTime) {
                canSave = false;
            } else if (this.editedItem.code === "") {
                settingsCompany = SettingsCompany.Settings.GenerateCode;
                let setting: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingsCompany);
                if (setting.length < 1) {
                    canSave = false;
                } else {
                    canSave = true;
                }
            }

            if (canSave) {
                if (!this.selectedTypesOutbound || !this.selectedTypesOutbound.id) {
                    this.$emit('showMessageWarning', 'Outbound Type is required!');
                    return;
                }

                if (!this.selectedCompanySource || !this.selectedCompanySource.id) {
                    this.$emit('showMessageWarning', 'Company Source is required!');
                    return;
                }

                if (!this.selectedCompanyDestination || !this.selectedCompanyDestination.id) {
                    this.$emit('showMessageWarning', 'Company Destination is required!');
                    return;
                }

                this.editedItem.idCompanySource = this.selectedCompanySource.id;
                this.editedItem.idCompanyDestination = this.selectedCompanyDestination.id;
                this.editedItem.companySourceName = this.selectedCompanySource.name;
                this.editedItem.companyDestinationName = this.selectedCompanyDestination.name;
                this.editedItem.idListTypesOutbounds = this.selectedTypesOutbound.id;
                this.editedItem.listTypesOutboundsName = this.selectedTypesOutbound.name;
                this.editedItem.idCustomer = this.selectedCustomer.id;
                this.editedItem.customerName = this.selectedCustomer.name;

                if (this.editedIndex > -1) {
                    this.applyStatusIfValid();
                } else {
                    if (!this.selectedStatusOutboundChange || !this.selectedStatusOutboundChange.id) {
                        this.$emit('showMessageWarning', 'Status is required');
                        return;
                    }
                    this.editedItem.idStatus = this.selectedStatusOutboundChange.id;
                    this.editedItem.statusName = this.selectedStatusOutboundChange.name;
                }

                let date = this.convertDate(new Date(this.editedItem.dateOut));
                if (date !== this.dateOut && this.editedIndex > -1) {
                    this.editedItem.dateChanged = true;
                }

                this.editedItem.dateOut = new Date(this.dateOut);
                this.editedItem.startTime = this.selectedStartTime;
                this.editedItem.endTime = this.selectedEndTime;

                if (this.editedItem.sealNumber === null) {
                    this.editedItem.sealNumber = "";
                }
                if (this.editedItem.containerNumber === null) {
                    this.editedItem.containerNumber = "";
                }
                if (this.editedItem.orderNumber === null) {
                    this.editedItem.orderNumber = "";
                }

                if (this.editedIndex > -1) {
                    this.$emit('editOutbound', this.editedItem);
                } else {
                    this.$emit('saveOutbound', this.editedItem);
                }

                this.close();
            } else {
                if (slot === 12) {
                    this.$emit('showMessageWarning', 'The 12-13 timeslot is reserved for the break. Select another timeslot.');
                } else if (slot > 0) {
                    this.$emit('showMessageWarning', `The selected timeslot from ${this.selectedStartTime} to ${this.selectedEndTime} exceeds the limit of 3 in/outbounds for hour ${slot}. Please choose another range.`);
                } else if (this.selectedStartTime > this.selectedEndTime) {
                    this.$emit('showMessageWarning', 'The end time cannot be less than the start time. Please select another time slot for the end time.');
                } else {
                    if (this.editedItem.code === "") {
                        this.$emit('showMessageWarning', 'This order number cannot be empty.');
                    } else {
                        this.$emit('showMessageWarning', 'This order number ' + this.editedItem.code + ' is already in use. Duplicate order numbers cannot be used.');
                    }
                }
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteOutbound(outbound: IOutbound) {
        this.$emit('deleteOutbound', outbound);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    select(item : IOutbound) : void {
        let index : number = this.selectedOutbound.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedOutbound = [item];
            this.$emit('input', item);
        } else {
            let outbound = this.selectedOutbound.find(w => w.id === item.id);
            if (!outbound) {
                this.selectedOutbound = [];
                this.$emit('input', null);
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
